import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styled from 'styled-components';

import { Button, message, Image } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

import FileUploader from '../../FileUploader/FileUploader';
import { deleteFile } from '../../../features/api/filesAPI';

const Wrapper = styled.div`
  position: absolute;
  bottom: 5%;
  right: 5%;
`;

export default function InterfaceLogoImg({ setInterfaceFileId, id }) {
  const [fileId, setFileId] = useState(id);
  const [fileName, setFileName] = useState('');
  const [imgUrl, setImgUrl] = useState('');
  const [isLoadingImg, setIsLoadingImg] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const updateFileId = (id) => {
    setFileId(id);
    setInterfaceFileId(id);
  };

  const clearFileId = () => {
    setFileId(-1);
    setInterfaceFileId(-1);
  };

  const deleteImage = async () => {
    setIsDeleting(true);
    await deleteFile(id);
    setIsDeleting(false);
    clearFileId();
  };

  useEffect(() => {
    const loadId = fileId || id;
    if (loadId) {
      setIsLoadingImg(true);
      axios
        .get(`/files?id=${loadId}`)
        .then(({ data: file }) => {
          setFileName(file.name);
          setImgUrl(file.url);
          setIsLoadingImg(false);
        })
        .catch((err) => {
          setIsLoadingImg(false);
          message.error('קובץ לוגו לא הצליח להטען');
        });
      return;
    }
    setImgUrl('');
  }, [fileId, id]);

  return (
    <Wrapper isImg={imgUrl?.length > 0}>
      {imgUrl?.length > 0 ? (
        <div style={{ position: 'relative' }}>
          <Image src={imgUrl} alt={fileName} width={'20%'} />
          <Button
            style={{ position: 'absolute', top: 0, right: 0 }}
            type="primary"
            danger
            icon={<DeleteOutlined />}
            onClick={deleteImage}
            loading={isDeleting}
          />
        </div>
      ) : (
        <FileUploader
          buttonText="העלאת לוגו"
          updateFileId={updateFileId}
          isLoading={isLoadingImg}
        />
      )}
    </Wrapper>
  );
}
